<!-- Model Header -->
<div class="d-flex model-container justify-content-between bg-color overflow-hidden">
    <h3 class="text-color f-w-600 p-l-10 m-y-auto">Edit Lead</h3>
    <button mat-icon-button class="text-color" (click)="this.dialogRef.close()" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<!-- Model Body -->
<div mat-dialog-content style="width: 100%; padding: 20px;" class="model-body">
    <form [formGroup]="leadForm">


        <div>
            <div class="">
                <div class="p-10">
                    <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Lead Detail</mat-label>
                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Name</mat-label>
                            <mat-form-field appearance="outline" class="disble w-100" color="primary">
                                <input class="disble" matInput type="email" formControlName="email" readonly />
                            </mat-form-field>
                        </div>

                        <!-- Email field 2 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Phone Number</mat-label>
                            <mat-form-field appearance="outline" class="disble w-100" color="primary">
                                <input class="disble" matInput type="email" formControlName="email" readonly />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Email</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Budget</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field>
                        </div>


                    </div>




                    <mat-label class="f-s-14 f-w-600 m-b-4 d-block">Commission Detail</mat-label>
                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Commission</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field>
                        </div>

                        <!-- Email field 2 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Assign Agents</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field>
                        </div>
                    </div>

                    <mat-label class="f-s-14 f-w-600 m-b-4 d-block">Status Detail</mat-label>
                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Status</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field>
                        </div>

                        <!-- Email field 2 -->
                    </div>
                </div>
            </div>
        </div>

    </form>
</div>

<!-- Model Footer -->
<div mat-dialog-actions>
    <button class="bg-color text-color" mat-button>Save</button>

    <button class="bg-color text-color" mat-button (click)="this.dialogRef.close()">Close</button>
</div>